$cookie-icon-url: 'https://marketing-static.signnow.com/350/images/global/modals/icon-cookie-font.png';

cookie-type-1 {
  .cookie-type-1 {
    @include desktop {
      max-width: 580px;
    }

    .cookie-type-1__content[class] {
      gap: var(--spacing-sm);
      padding: var(--spacing-md) var(--spacing-lg);
    }

    .cookie-type-1__close {
      top: 0.125rem;
      right: 0.125rem;
    }

    .cookie-type-1__description-text {
      @include text-style(xs, md);

      p,
      span,
      div {
        @include text-style(xs, md);
      }

      @include desktop {
        @include text-style(sm, lg);

        p,
        span,
        div {
          @include text-style(sm, lg);
        }
      }
    }

    .cookie-type-1__actions {
      me-button {
        display: block;
        width: 100%;
        font-size: map-get($font-sizes, sm);

        .me-button {
          width: 100%;
          font-size: map-get($font-sizes, sm);

          // 36px tall: 24px line-height + 2×2px border + 2×4px padding. The label font drops to
          // `sm` on mobile and returns to the inherited size at desktop, so the line box is pinned
          // here — otherwise the height would differ between the two.
          line-height: 1.5rem;
          padding: 0.25rem 1rem;
        }
      }

      @include desktop {
        me-button {
          display: inline-flex;
          width: auto;
          font-size: inherit;

          .me-button {
            // 96×36 on desktop; on mobile the button stays full-width, as designed.
            width: auto;
            min-width: 96px;
            font-size: inherit;
          }
        }
      }
    }

    @include desktop {
      .cookie-type-1__content[class] {
        gap: 0;
        padding: var(--spacing-md) var(--spacing-3xl) var(--spacing-md) var(--spacing-md);

        &::before {
          content: '';
          display: block;
          width: var(--spacing-lg);
          height: var(--spacing-lg);
          min-width: var(--spacing-lg);
          background-image: url($cookie-icon-url);
          background-size: contain;
          background-repeat: no-repeat;
          background-position: center;
          flex-shrink: 0;
          align-self: flex-start;
          margin-right: 0.625rem;
        }
      }

      .cookie-type-1__actions {
        margin-left: var(--spacing-xl);
      }
    }
  }
}

[data-color-mode='signnow'] {
  cookie-type-1 {
    .cookie-type-1 {
      border-radius: map-get($border-radii, md);

      .cookie-type-1__content {
        // 16px 20px on mobile; 14px 40px 14px 20px from desktop up. 14px has no token of its
        // own — it is the `md` step less the 2px border the banner card carries.
        padding: var(--spacing-md) var(--spacing-lg);
        border-radius: map-get($border-radii, md);

        @include desktop {
          padding: calc(var(--spacing-md) - 2px) var(--spacing-3xl) calc(var(--spacing-md) - 2px)
            var(--spacing-lg);
        }
      }

      .me-text {
        font-size: map-get($font-sizes, sm);
      }
    }
  }
}
